import React from "react";
import LModal from "../../../../../../common/components/Modals/LModal/LModal";
import ModalHeader from "../../../../../../common/components/Modals/ModalHeader/ModalHeader";

interface IAIAMultiBenefitDiscountModalProps {
    isOpen: boolean;
    onClose: () => void;
}

/**
 *  This is based on the content from https://www.lifedirect.co.nz/article/aia
 */

const AIAMultiBenefitDiscountModal: React.FC<IAIAMultiBenefitDiscountModalProps> = (
    props
) => {
    const { isOpen, onClose } = props;

    return (
        <LModal
            Header={() => (
                <ModalHeader onClose={onClose} title="AIA Multi-benefit discount" />
            )}
            calcHeightMode="auto"
            width="wide"
            isOpen={isOpen}
            onClose={onClose}>
            {() => (
                <React.Fragment>
                    <h3>Multi-Benefit Discount</h3>
                    <p>We want to make insurance affordable for you and your family.</p>
                    <p>
                        Insurance is an important part of setting yourself up financially,
                        protecting you and your family&apos;s health, wealth and
                        wellbeing. We know the cost of living in New Zealand is high and
                        you have everyday expenses to manage, so we&apos;ll do what we can
                        to help you out.
                    </p>
                    <h4>Eligible products across our insurance categories</h4>
                    <p>
                        If you have two or more eligible insurances with AIA you may be
                        able to access a discount on your AIA Living insurance premiums as
                        outlined in the table below.
                    </p>
                    <img src="/images/contenthub/articles/embedded/multi-benefit-discount-table1.svg"></img>
                    <p className="gap-m text-light">
                        * When converting your Family Protection insurance to a lump sum
                        amount over the entire benefit term.
                    </p>
                    <h4>Discount tiers</h4>
                    <p>
                        If you are eligible for a Multi-Benefit Discount you&apos;ll be
                        entitled to the following discount: Do you have existing policies
                        with us?
                    </p>
                    <img src="/images/contenthub/articles/embedded/multi-benefit-discount-table2.svg"></img>
                    <h4>Do you have existing policies with us?</h4>
                    <p>
                        When you take up new policies with AIA, we&apos;ll take into
                        consideration eligible existing insurance you have with us to see
                        if you qualify for the Multi-Benefit Discount. If you&apos;re
                        eligible for the discount, this will then be applied to your new
                        policies premium only.
                    </p>
                    <h4>Optional benefits eligible to receive the discount</h4>
                    <p>
                        The following optional benefits will not count towards eligibility
                        within the product categories, but qualify to receive the
                        discount.
                    </p>
                    <p>Examples of optional benefits include:</p>
                    <ul>
                        <li>Waiver of Premium</li>
                        <li>Premier Cover</li>
                        <li>Redundancy Cover</li>
                        <li>Retirement Protection</li>
                        <li>Children&apos;s and Maternity</li>
                        <li>Life Buy-back</li>
                        <li>Critical Conditions Buy-back</li>
                        <li>Early Cancer Upgrade</li>
                        <li>Accidental Injury Cover</li>
                        <li>Total Permanent Disablement Condition</li>
                        <li>Future Insurability</li>
                    </ul>
                </React.Fragment>
            )}
        </LModal>
    );
};

export default AIAMultiBenefitDiscountModal;
